import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class TooSmallDefaultDiscountValueWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Warning, 'business.client.validation.default-discount.too-small');
    }
}
